import { createFileRoute } from '@tanstack/react-router'
import { ServiceVisitPage } from '../../../../../features/service/visit-page'

export const Route = createFileRoute('/_app/service/visits/$visitId/')({
  component: ServiceVisitPage,
})
